import { useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { Player } from '../../database.schema';

export type Price = {
  month: string;
  price: string;
};
export type Prices = Record<string, Price[]>;
export type Month = Record<string, string[]>;
export type MonthBookedAvailability = Record<string, number[]>;

type PlayerData = {
  player: Player;
  playerIndex: number;
};

const mutatePlayer = async (playerData: PlayerData): Promise<PlayerData> => {
  const authToken = Cookies.get('token');
  var dbDNS = `https://golf-tour-462cf-default-rtdb.europe-west1.firebasedatabase.app/players/${playerData.playerIndex}/.json?auth=${authToken}`;
  if (process.env.REACT_APP_MODE === 'dev') {
    dbDNS = `http://127.0.0.1:9000/players/${playerData.playerIndex}/.json?ns=golf-tour-462cf-default-rtdb&auth=${authToken}`;
  }
  const response = await fetch(dbDNS, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...playerData.player }),
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
};

export const usePlayerMutation = () => {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: mutatePlayer,
    onSuccess: (data) => {
      // Invalidate and refetch
      // queryClient.invalidateQueries({ queryKey: ['availability'] });
    },
  });
};
